
import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const dietSlice = createSlice({
    name: 'diets',
    loading: false,
    initialState: {
        dietlist: [],
        dietCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.dietlist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.dietlist = action.payload.data?action.payload.data:[];
            state.dietCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = dietSlice.actions;
//console.log(body);
export const fetchDiets = ()=> apiCallBegan({
    url: '/product_ingredients/list',
    method: 'post',
    data: {status: true, type: 3, sortByField: "ordering", sortByValue: 1},
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














